import React from 'react';
import { Box, Button, Flex, Heading } from 'rebass';
import 'react-table-v6/react-table.css';
import styled from 'styled-components';
import JourneysList from './adminMobileCourse/Journeys';
import ScreenFormatList from './adminMobileCourse/ScreenFormats';
import CoursesList from './adminMobileCourse/CoursesList';
import ConfirmModal from '../components/ConfirmModal';
import EditPaymentScreen from './adminPresetPlan/modals/EditPaymentScreen';
import PleaseWait from '../components/PleaseWait';
import { useState } from 'react';
import { ADMIN_GET_COURSE_PAYMENT_SCREEN } from '../graphql';
import { Query } from 'react-apollo';

const Container = styled(Box)`
  max-width: 900px;
  width: 100%;
  margin: 0 auto;
  padding: 48px 6px 0 6px;
`;
const ModalInner = styled(Box)`
  max-width: 80vw;
  width: 80vw;
  max-height: 90vh;
  overflow-y: auto;
`;

const MobileCourses = () => {
  const [isEditPaymentScreen, setIsEditPaymentScreen] = useState(false);
  return (
    <Container>
      <Flex>
        <Heading flex={1}>MOBILE COURSES</Heading>
        <Button
          style={{ background: '#344f79' }}
          onClick={() => {
            setIsEditPaymentScreen(true);
          }}
        >
          Edit Payment Screen
        </Button>
      </Flex>

      <JourneysList />
      <ScreenFormatList />
      <CoursesList />
      <ConfirmModal
        childrenManaged
        isOpen={isEditPaymentScreen}
        confirmLabel="create"
        onClose={() => {
          setIsEditPaymentScreen(false);
        }}
        onBackgroundClick={() => {
          setIsEditPaymentScreen(false);
        }}
        onEscapeKeydown={() => {
          setIsEditPaymentScreen(false);
        }}
        onConfirm={() => {
          setIsEditPaymentScreen(false);
        }}
      >
        <ModalInner>
          <Heading fontSize="20px" mb={'20px'}>
            EDIT PAYMENT SCREEN
          </Heading>
          <Query query={ADMIN_GET_COURSE_PAYMENT_SCREEN} variables={{ courseId: 'AIP' }}>
            {({ loading, data }) => {
              if (!!loading) return <PleaseWait />;

              return (
                <EditPaymentScreen
                  initialValues={(data || {}).getMobileCoursePaymentScreen}
                  courseId={'AIP'}
                  onSave={() => {
                    setIsEditPaymentScreen(false);
                  }}
                  onClose={() => setIsEditPaymentScreen(false)}
                />
              );
            }}
          </Query>
        </ModalInner>
      </ConfirmModal>
    </Container>
  );
};

export default MobileCourses;
